module.exports = __webpack_public_path__ + "img/instrument-market.d3e7a2f6.png";